import React from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export default function PolaroidPhoto({vispart,photoName,href,...props}){
    const photoPin = "/assets/images/photo-pin.png"
    return(
        <Button {...props}
            href={href || undefined}
        >
            <div className="PolaroidPhoto">
                <img src={photoPin} alt="pin thumbtack" className="Polaroid-pin"/>
                <img src={vispart} alt={photoName} className="Polaroid-vis"/>
                <Typography variant="caption">{photoName}</Typography>
            </div>
            
        </Button>
    );
}